<template>
  <page-layout
    :title="courseTitle"
    v-loading="!pageInit"
    :icon-config="{
      isBack: true,
      isImg: false,
      backText
    }"
    helpMode="dataCleaner"
  >
    <div slot="custom-title" class="course-title-content">
      <el-tooltip effect="dark" placement="bottom">
        <div slot="content" :style="{ maxWidth: '300px' }">{{ courseTitle }}</div>
        <div class="title-text single-ellipsis">{{ courseTitle }}</div>
      </el-tooltip>
    </div>

    <course-invite slot="custom-btn" v-if="courseDetail" :courseDetail="courseDetail" />

    <div class="data-cleaner" v-if="!!courseDetail">
      <div class="header-content">
        <el-select
          v-model="crimeReason"
          :style="{ width: '140px', marginRight: '10px' }"
          size="mini"
          clearable
          filterable
          remote
          :remote-method="fetchCrimeReasonArr"
          placeholder="请输入搜索案由"
          @change="changeReasonHandler()"
        >
          <el-option :value="''" label="全部案由" />
          <el-option
            v-for="crimeReasonText in crimeReasonArr"
            :key="crimeReasonText"
            :value="crimeReasonText"
            :label="crimeReasonText"
          />
        </el-select>

        <el-select
          ref="unitSelectRef"
          v-model="unitVal"
          :style="{ width: '200px', marginRight: '10px' }"
          size="mini"
          @change="changeUnitHandler()"
          popper-class="unit-select-popover"
        >
          <div class="unit-select-popover-tip">
            <span>视图分组</span>
            <el-tooltip effect="dark" content="以分组为中心，进行数据标注及数据查看" placement="top-start">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <el-option
            v-for="unitGroup in courseUnitGroups"
            :key="unitGroup.id"
            :value="unitGroup.id"
            :label="unitGroup.name"
          >
            <div class="unit-select-item-content">
              <div class="unit-select-item-title single-ellipsis">
                <span>{{ unitGroup.name }}</span>
                <el-button type="text" @click.stop="delUnitModal.init(unitGroup)" v-if="!unitGroup.isSysGroup">
                  <span>删除</span>
                </el-button>
              </div>
              <div class="unit-select-item-desc">
                <span>{{ unitGroup.desc || '-' }}</span>
              </div>
            </div>
          </el-option>
          <el-button type="text" :style="{ padding: '14px 20px 10px' }" @click.stop="showGroupEditor()">
            <span>自定义分组</span>
          </el-button>
        </el-select>

        <div class="filter-info">
          <filter-tips
            :courseId="courseDetail._id"
            isNowrap
            themeClass="theme-2"
            :fieldThemeEnum="fieldThemeEnum"
            collapseTextFilter
            :byCourse="isCourseCleaner"
            :sortInfoCustom="curSortInfoCustom"
            :courseFilterArr="courseFilterArr"
            :researchFilterArr="conditionFilterArr"
            @updFilter="filterItem => this.$refs.originDataTableRef.showFilterHandle({ filterItem })"
            @delFilter="params => delFilterHandle(params.type, params.index)"
            @delSort="params => sortHandle(params.action, { headerItem: params.fieldInfo })"
            @delSortCustom="changeSortInfoCustom()"
          >
            <el-button slot="btn" type="text" class="collect-filter-tag-btn" v-if="collectShow">
              <span>收藏</span>
              <span v-if="collectGroup"> - {{ collectGroup | collectGroupFilter(collectGroupList) }}</span>
              <i class="el-icon-close" @click="tapShowHandle('collectShow')"></i>
            </el-button>
            <el-button slot="btn" type="text" class="collect-filter-tag-btn" v-if="uploadShow">
              <span>仅看导入</span>
              <i class="el-icon-close" @click="tapShowHandle('uploadShow')"></i>
            </el-button>
          </filter-tips>
        </div>
        <div class="filter-total" v-show="resetDelShow">
          <span class="filter-first">共 {{ pageInfo.total.toLocaleString() }} 个</span>
        </div>
        <div class="filter-total" v-show="!resetDelShow">
          <span :style="{ color: '#1991FB' }">
            <i class="iconfont iconshaixuan"></i>
            <span :style="{ margin: '0 3px' }">{{ pageInfo.total.toLocaleString() }}</span>
            <span>条</span>
          </span>
          <span :style="{ marginLeft: '3px' }">共</span>
          <span :style="{ margin: '0 3px' }">{{ caseTotal }}</span>
          <span>起案件</span>
        </div>
        <exportAndImport
          :style="{ marginLeft: '10px' }"
          v-show="!resetDelShow"
          hideExport
          :unitVal="unitVal"
          :courseDetail="courseDetail"
          :researchModel="currentResearch"
          :dataSource="mergeDataSource"
          @importSuccess="importSuccessHandle"
        />
      </div>

      <div class="page-content" ref="pageContentRef">
        <div
          class="origin-data-content"
          :class="[originDataHide && 'is-hide', fieldPaneInfo.show && 'is-absolute']"
          ref="originDataRef"
          :style="{ width: `${originDataWidth}px`, left: `${-(originDataHide ? originDataWidth : 0)}px` }"
          v-loading="tableLoading"
        >
          <div class="expand-btn" @click="() => ((originDataHide = !originDataHide), (preOriginDataHide = ''))">
            <i class="el-icon-arrow-left"></i>
          </div>
          <div class="origin-data-content-container">
            <origin-data
              ref="originDataTableRef"
              :hits="tableList"
              :instrumentType="courseDetail ? courseDetail._source.instrumentType : ''"
              :currentRecommend="currentRecommend"
              :byCourse="isCourseCleaner"
              :courseFilterArr="courseFilterArr"
              :filter-arr="conditionFilterArr"
              :show-filter="false"
              :page="pageInfo.page"
              :size="pageInfo.size"
              :show-pagination="false"
              :courseId="courseDetail._id"
              :courseCondition="courseDetail._source.condition"
              :tableColumns="tableColumns"
              :tool-actions="toolActions"
              :high-row-id="scrollCaseId"
              :unitGroup="curUnitGroup"
              :filterUnitGroupName="curUnitGroup.name"
              full-height
              byCleaner
              @tapRow="row => (scrollCaseId = row.caseId)"
              @hideFieldOfAllGroup="({ headerItem }) => hideFieldHandle(headerItem, true)"
              @hideFieldOfGroup="({ headerItem }) => hideFieldHandle(headerItem, false)"
              @changeFilter="changeTableFilter"
              @asc="params => sortHandle('asc', params)"
              @desc="params => sortHandle('desc', params)"
              @customSort="({ headerItem }) => customSortModalShowHandle(headerItem)"
              @label="params => filterLabelHandle('label', params)"
              @noneLabel="params => filterLabelHandle('none', params)"
              @agg="({ headerItem }) => updAggFieldHandle('agg', headerItem)"
              @notAgg="({ headerItem }) => updAggFieldHandle('notAgg', headerItem)"
              @customAgg="() => updAggFieldHandle('customAgg')"
            />
          </div>
          <div class="case-list-footer">
            <span v-show="resetDelShow"></span>
            <exportAndImport
              v-show="!resetDelShow"
              hideImport
              :unitVal="unitVal"
              :courseDetail="courseDetail"
              :researchModel="currentResearch"
              :dataSource="mergeDataSource"
              :uploadShow="uploadShow"
              @importSuccess="importSuccessHandle"
            />

            <span class="case-list-footer-pagination">
              <el-pagination
                @current-change="changePageFilterHandle()"
                :total="pageInfo.total"
                :current-page.sync="pageInfo.page"
                :page-size="pageInfo.size"
                layout="jumper, prev, next"
              />
              <span>共{{ Math.ceil(pageInfo.total / pageInfo.size) }}页</span>
            </span>
          </div>
          <div class="drag-item" draggable @dragstart="dragstartHandle" @dragend="dragendHandle"></div>
        </div>

        <div class="case-list-content">
          <div class="container">
            <div class="case-list-header">
              <div class="case-list-header-form">
                <div class="case-list-header-form-li">
                  <div class="case-list-header-form-li-label">显示段落</div>
                  <el-cascader
                    :style="{ width: '170px' }"
                    v-model="selectParagraphArrIds"
                    :options="paragraphTree"
                    placeholder="全文"
                    collapse-tags
                    clearable
                    :show-all-levels="false"
                    :props="{
                      expandTrigger: 'click',
                      multiple: true,
                      checkStrictly: true,
                      emitPath: false,
                      value: 'key',
                      label: 'value'
                    }"
                    @change="changeSelectParagraphHandle"
                  />
                </div>
                <div class="case-list-header-form-li" :style="{ flex: 1, width: 0 }">
                  <div class="twin-content">
                    <el-autocomplete
                      class="twin-autocomplete"
                      popper-class="datacleaner-filter-input-popper"
                      clearable
                      v-model="labelText"
                      :fetch-suggestions="(str, cb) => cb([true])"
                      placeholder="请输入内容"
                      prefix-icon="el-icon-search"
                      @keyup.enter.native="confirmTextFilterHandle"
                    >
                      <div class="datacleaner-filter-input-tip">
                        <div class="datacleaner-filter-input-tip-title">输入提示：</div>
                        <div class="datacleaner-filter-input-tip-item">
                          <span>关键词之间用空格或“ + ”加号代表“且”的搜索逻辑（如：多次+扒窃）</span>
                        </div>
                        <div class="datacleaner-filter-input-tip-item">
                          <span>关键词之间用“ | ”竖线的符号表示“或”的搜索逻辑（如：入户盗窃|入室盗窃）</span>
                        </div>
                        <div class="datacleaner-filter-input-tip-item">
                          <span>关键词前面用“ - ”减号表示“不包含”的搜索逻辑（如：-累犯）</span>
                        </div>
                      </div>
                    </el-autocomplete>
                    <el-button class="twin-btn" type="primary" :disabled="!labelText" @click="confirmTextFilterHandle">
                      <span>搜索</span>
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="case-list-header">
              <div class="case-list-header-form">
                <div class="case-list-header-form-li">
                  <div class="switch-content">
                    <span>高亮</span>
                    <el-switch class="switch-item" v-model="justShowHighText" active-color="#13ce66" />
                  </div>
                </div>
                <div class="case-list-header-form-li">
                  <div class="switch-content">
                    <span>全文</span>
                    <el-switch class="switch-item" v-model="articleShow" active-color="#13ce66" />
                  </div>
                </div>
                <div class="case-list-header-form-li">
                  <div class="switch-content">
                    <el-button
                      type="text"
                      class="text-btn"
                      :class="collectShow && 'is-active'"
                      :disabled="disabledFilter('collectShow')"
                      @click="tapShowHandle('collectShow')"
                    >
                      <span>收藏</span>
                      <i class="iconfont iconzuozhankai-xiantiao"></i>
                    </el-button>
                  </div>
                </div>
                <div class="case-list-header-form-li">
                  <div class="switch-content">
                    <el-button
                      type="text"
                      class="text-btn"
                      :class="showBatchConfirm && 'is-active'"
                      :disabled="disabledFilter('showBatchConfirm')"
                      @click="tapShowHandle('showBatchConfirm')"
                    >
                      <span>标注案件</span>
                      <i class="iconfont iconzuozhankai-xiantiao"></i>
                    </el-button>
                  </div>
                </div>
                <div class="case-list-header-form-li">
                  <div class="switch-content">
                    <el-button
                      type="text"
                      class="text-btn"
                      :class="mulitDelShow && 'is-active'"
                      :disabled="disabledFilter('mulitDelShow')"
                      @click="tapShowHandle('mulitDelShow')"
                    >
                      <span>批量删除</span>
                      <i class="iconfont iconzuozhankai-xiantiao"></i>
                    </el-button>
                  </div>
                </div>
                <div class="case-list-header-form-li">
                  <div class="switch-content">
                    <el-button
                      type="text"
                      class="text-btn"
                      :class="resetDelShow && 'is-active'"
                      :disabled="disabledFilter('resetDelShow')"
                      @click="tapShowHandle('resetDelShow')"
                    >
                      <span>删除历史</span>
                      <i class="iconfont iconzuozhankai-xiantiao"></i>
                    </el-button>
                  </div>
                </div>
                <div class="case-list-header-form-li">
                  <el-popover
                    placement="bottom-end"
                    title=""
                    :width="sortCascaderExpandArr.length > 0 ? 358 : 180"
                    trigger="hover"
                    ref="sortPopoverRef"
                  >
                    <div class="switch-content" slot="reference">
                      <el-button type="text" class="text-btn">
                        <template v-if="curSortInfo">
                          <span>{{ curSortInfo.fieldInfo.title }}</span>
                          <span>{{ curSortInfo.action === 'asc' ? '升序' : '降序' }}</span>
                        </template>
                        <span v-else>默认排序</span>
                        <i class="iconfont iconshouqi-xiantiao"></i>
                      </el-button>
                    </div>

                    <el-cascader-panel
                      :value="sortVal"
                      :options="sortOptions"
                      :props="{
                        expandTrigger: 'hover'
                      }"
                      @change="changeSortHandle"
                      @expand-change="val => (sortCascaderExpandArr = val)"
                    />
                  </el-popover>
                </div>
                <div class="case-list-header-form-li">
                  <div class="switch-content">
                    <el-button
                      type="text"
                      class="text-btn"
                      :class="uploadShow && 'is-active'"
                      :disabled="disabledFilter('uploadShow')"
                      @click="tapShowHandle('uploadShow')"
                    >
                      <span>仅看导入</span>
                      <i class="iconfont iconzuozhankai-xiantiao"></i>
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
            <div class="case-tool-header recommend-content" v-if="currentRecommend">
              <span class="tip-text">
                <span>智能推荐“</span>
                <span>{{ currentRecommend.title }}</span>
                <span>”标签的 </span>
                <span>{{ pageInfo.total.toLocaleString() }}</span>
                <span> 个相似描述</span>
              </span>
              <div>
                <el-button
                  size="mini"
                  type="primary"
                  :disabled="pageInfo.total === 0"
                  :loading="recommendLoading"
                  @click="confirmRecommendHandle({ isClear: false })"
                >
                  <span>一键确认标注</span>
                </el-button>
                <el-button
                  size="mini"
                  :disabled="pageInfo.total === 0"
                  :loading="recommendLoading"
                  @click="confirmRecommendHandle({ isClear: true })"
                >
                  <span>一键清空推荐结果</span>
                </el-button>
              </div>
              <i class="iconfont iconcha close-btn" @click="checkRecommendHandle()"></i>
            </div>
            <div class="case-tool-header recommend-content" v-else-if="mulitDelShow">
              <div>
                <el-checkbox :value="mulitAllCheck" @change="checkAllHandle">
                  <span>全选本页</span>
                </el-checkbox>
              </div>
              <div>
                <el-button
                  type="danger"
                  :disabled="mulitCheckArr.length === 0"
                  :loading="delMulitLoading"
                  @click="delCaseMulitHandle"
                >
                  <span>删除</span>
                </el-button>
                <el-button type="danger" :disabled="caseTotal === 0" :loading="delAllLoading" @click="delAllCaseHandle">
                  <span>删除筛选条件下所有案件</span>
                </el-button>
              </div>
              <i class="iconfont iconcha close-btn" @click="mulitDelShow = false"></i>
            </div>
            <div class="case-tool-header recommend-content" v-else-if="resetDelShow">
              <div>
                <el-checkbox :value="mulitAllCheck" @change="checkAllHandle">
                  <span>全选本页</span>
                </el-checkbox>
              </div>
              <div>
                <el-button
                  type="primary"
                  plain
                  :disabled="mulitCheckArr.length === 0"
                  :loading="resetDelLoading"
                  @click="resetCaseMulitHandle"
                >
                  <span>恢复</span>
                </el-button>
                <el-button
                  type="primary"
                  :disabled="caseTotal === 0"
                  :loading="resetAllLoading"
                  @click="resetAllCaseHandle"
                >
                  <span>恢复筛选条件下所有案件</span>
                </el-button>
              </div>
              <i class="iconfont iconcha close-btn" @click="tapShowHandle('resetDelShow')"></i>
            </div>
            <div class="case-tool-header" v-else-if="showBatchConfirm">
              <span class="tip-text">
                <span>把 </span>
                <span>{{ pageInfo.total.toLocaleString() }}</span>
                <span> 个搜索结果的案件标注为</span>
              </span>
              <el-select
                :style="{ marginLeft: '10px' }"
                size="mini"
                placeholder="请选择标签"
                v-model="batchField.field"
                value-key="columnKey"
                filterable
                @change="changeFieldHandle"
              >
                <el-option
                  v-for="fieldItem in curFields"
                  :key="fieldItem.columnKey"
                  :label="fieldItem.title"
                  :value="fieldItem"
                  :disabled="fieldItem.type !== 'text'"
                />
              </el-select>
              <el-select
                v-show="batchField.field && batchField.field.type === 'text' && batchField.field.deputy_type === 'dict'"
                :style="{ marginLeft: '10px' }"
                size="mini"
                placeholder="请选择或检索标签分类"
                v-model="batchField.typeVal"
                filterable
                :loading="fieldTypeLoading"
                remote
                :remote-method="fetchFieldTypeVal"
              >
                <el-option
                  v-for="(typeItem, typeIndex) in fieldTypeVal"
                  :key="typeIndex"
                  :label="typeItem"
                  :value="typeItem"
                />
              </el-select>
              <el-button
                size="mini"
                type="primary"
                :style="{ marginLeft: '10px' }"
                :loading="batchLoading"
                @click="batchConfirmFieldHandle({ isClear: false })"
              >
                <span>所有案件标注该标签</span>
              </el-button>
              <el-button
                size="mini"
                class="blue-btn"
                :loading="batchLoading"
                @click="batchConfirmFieldHandle({ isClear: true })"
              >
                <span>所有案件清空该标签</span>
              </el-button>
              <i class="iconfont iconcha close-btn" @click="showBatchConfirm = false"></i>
            </div>
            <div class="case-tool-header" v-else-if="collectShow">
              <el-select
                size="mini"
                placeholder="请选择收藏夹"
                v-model="collectGroup"
                filterable
                clearable
                @change="refreshPageHandle()"
              >
                <el-option
                  v-for="groupItem in collectGroupList"
                  :key="groupItem.id"
                  :label="groupItem.groupName"
                  :value="groupItem.id"
                />
              </el-select>
              <i class="iconfont iconcha close-btn" @click="tapShowHandle('collectShow')"></i>
            </div>
            <div class="card-content" v-loading="tableLoading">
              <case-label-editor
                v-if="isInit"
                ref="caseLabelEditor"
                :courseId="courseDetail._id"
                :instrumentType="courseDetail._source.instrumentType"
                :tableList="caseList"
                :listLoading="tableLoading"
                :fields="curFields"
                :highLightFields="highLightFields"
                :taskQueueIds="statisticsStatus.pending"
                :scrollId.sync="scrollCaseId"
                :searchOfParagraph="searchOfParagraph"
                :selectParagraphArr="selectParagraphArr"
                :justShowHighText="justShowHighText"
                :articleShow="articleShow"
                :allParagraphShow="allParagraphShow"
                :caseTagArr="caseTagArr"
                :recommendValue="recommendFieldPromise.value"
                :isRecommendMode="!!currentRecommend"
                :resetDelShow="resetDelShow"
                :mulitCheckShow="mulitDelShow || resetDelShow"
                :mulitCheckArr="mulitCheckArr"
                @createField="fieldDefaultInfo => showFieldPaneHandle('createField', { fieldDefaultInfo })"
                @updMulitCase="updMulitCaseHandle"
                @collect="collectHandle"
                @allParagraphShowHandle="allParagraphShowHandle"
                @updCaseLabelRelation="updCaseLabelRelationHandle"
                @addCaseLabel="addCaseLabelHandle"
                @delCaseLabel="delCaseLabelHandle"
                @updCaseLabel="updCaseLabelHandle"
                @delCase="delCaseHandle"
              >
                <div class="card-pagition" slot="custom-footer" v-show="caseList.length > 0">
                  <el-button
                    :disabled="'prev' | pageFilterDisabled(pageInfo)"
                    type="text"
                    @click="changePageHandle('prev')"
                  >
                    <i class="el-icon-arrow-left"></i>
                    <span>上一页</span>
                  </el-button>
                  <el-button
                    :disabled="'next' | pageFilterDisabled(pageInfo)"
                    type="text"
                    @click="changePageHandle('next')"
                  >
                    <span>下一页</span>
                    <div class="el-icon-arrow-right"></div>
                  </el-button>
                </div>
              </case-label-editor>
            </div>
          </div>
        </div>

        <div class="field-pane-content" v-if="fieldPaneInfo.show">
          <field-pane
            :show.sync="fieldPaneInfo.show"
            :mode="fieldPaneInfo.mode"
            :fieldDetail="fieldPaneInfo.fieldDetail"
            :fieldDefaultInfo="fieldPaneInfo.fieldDefaultInfo"
            :courseDetail="courseDetail"
            :dataSource="mergeDataSource"
            :chartIndexId="chartIndexId"
            @clearRecommend="fieldDetail => confirmRecommendHandle({ isClear: true, justClear: true, fieldDetail })"
            @updCourseDetail="detail => refreshCourseDetail(detail)"
          />
        </div>

        <div class="statistics-pane-content" :class="statisticsHide ? 'is-hide' : ''" v-show="!fieldPaneInfo.show">
          <div class="expand-btn" @click="statisticsHide = !statisticsHide">
            <i class="el-icon-arrow-right"></i>
          </div>
          <statistics-pane
            ref="statisticsRef"
            :fields="curFields"
            :unitGroup="curUnitGroup"
            :unitGroupList="courseUnitGroups"
            :courseDetail="courseDetail"
            :researchModel="currentResearch"
            :dataSource="mergeDataSource"
            :fetchQueryBody="fetchQueryBody"
            :currentRecommend="currentRecommend"
            :hideAutoTagTools="resetDelShow"
            @showFieldsEditor="fieldsModalShow = true"
            @updFieldsHideAndSort="updFieldsHideAndSort"
            @recommend="fieldDetail => checkRecommendHandle(fieldDetail)"
            @updRecommendTotal="updRecommendTotalHandle"
            @removeField="item => removeFieldHandle({ headerItem: item })"
            @delField="delFieldHandle"
            @createField="fieldDefaultInfo => showFieldPaneHandle('createField', { fieldDefaultInfo })"
            @editField="params => showFieldPaneHandle('updateField', params)"
            @importField="mode => showFieldPaneHandle(mode)"
            @changeTaskStatus="status => (statisticsStatus = status)"
            @changeRuleArrInfo="infoArr => (highLightFields = infoArr)"
            @label="params => filterLabelHandle('label', params)"
            @noneLabel="params => filterLabelHandle('none', params)"
            @resetFieldTag="resetFieldTagHandle"
          />
        </div>
      </div>
    </div>

    <field-reset-modal
      v-if="resetModal.show"
      :show.sync="resetModal.show"
      :fieldDetail="resetModal.fieldDetail"
      :courseId="courseDetail._id"
      @success="resetSuccessHandle"
    />

    <collectModal
      v-if="collectModal.show"
      :show.sync="collectModal.show"
      :courseId="courseDetail._id"
      :detail="collectModal.detail"
      @success="collectSuccess"
      @refreshGroup="initGroupHandle"
    />

    <fieldsEditor
      v-if="fieldsModalShow"
      :show.sync="fieldsModalShow"
      :courseDetail="courseDetail"
      :researchModel="currentResearch"
      @success="detail => refreshCourseDetail(detail)"
    />

    <groupEditorModal
      v-if="groupEditorShow"
      :show.sync="groupEditorShow"
      :courseId="courseDetail._id"
      @change="refreshUniGroup()"
    />

    <groupDelModal
      v-if="delUnitModal.show"
      :show.sync="delUnitModal.show"
      :courseId="courseDetail._id"
      :groupDetial="delUnitModal.detail"
      @success="delGroupAfterHandle"
    />

    <customAggEditorModal
      v-if="customAggEditorShow"
      :show.sync="customAggEditorShow"
      :curUnitGroup="curUnitGroup"
      :notAggFieldNames="notAggFieldNames"
      @change="customAggChange"
    />

    <customSortModal
      v-if="customSortModal.show"
      :show.sync="customSortModal.show"
      :courseId="courseDetail._id"
      :groupName="curUnitGroup.name"
      :defaultFieldDetail="customSortModal.fieldDetail"
      :fields="curFields"
      :defaultSortInfoCustom="curSortInfoCustom"
      @change="changeSortInfoCustom"
    />
  </page-layout>
</template>

<script>
import originData from '@/components/originData';
import fieldPane from './components/fieldPane';
import filterTips from '@/components/filterTips';
import statisticsPane from './components/statisticsPane';
import caseLabelEditor from './components/caseLabelEditor';
import fieldResetModal from './components/fieldResetModal';
import courseInvite from '@/components/courseInvite/index';
import exportAndImport from './components/exportAndImport';
import collectModal from '@/components/collectModal';
import fieldsEditor from '@/components/fieldsEditor';
import groupEditorModal from './components/groupEditorModal/index.vue';
import groupDelModal from './components/groupEditorModal/groupDelModal.vue';
import customAggEditorModal from './components/customAggEditorModal.vue';
import customSortModal from '@/components/customSortModal.vue';

import { services } from '@/service';
import { debounce, uniqBy } from 'lodash';
import { getSortInfo, fetchFieldsQuery, arrayToTree, sortFields } from '@/lib/utils';
import { fullCrimeReason, caseNumber, caseBaseTitle, judgementDate, sysCaseWays } from '@/constant';
import eventBus from '@/lib/eventBus';
import { computed } from 'vue';

const defaultPageInfo = {
  total: 0,
  page: 1,
  size: process.env.NODE_ENV === 'development' ? 1 : 30
};

export default {
  components: {
    originData,
    statisticsPane,
    caseLabelEditor,
    filterTips,
    fieldResetModal,
    courseInvite,
    exportAndImport,
    collectModal,
    fieldPane,
    fieldsEditor,
    groupEditorModal,
    groupDelModal,
    customAggEditorModal,
    customSortModal
  },
  data() {
    return {
      isInit: false,
      pageInit: false,
      chartIndexId: -1,
      courseDetail: null,
      tableLoading: false,
      firstTotal: -1,
      pageInfo: { ...defaultPageInfo },
      caseTotal: 0,
      labelText: '',
      selectParagraphArrIds: [],
      preSelectParagraphArrIds: [],
      paragraphTree: [],
      caseList: [],
      tableList: [],
      statisticsHide: false,
      originDataHide: false,
      preOriginDataHide: '',
      statisticsStatus: {
        pending: []
      },
      highLightFields: [],
      courseFilterArr: [],
      conditionFilterArr: [],
      courseSortInfo: null,
      researchSortInfo: null,
      courseSortInfoCustom: null,
      researchSortInfoCustom: null,
      customSortModal: {
        show: false,
        fieldDetail: null
      },
      scrollCaseId: '',
      originDataWidth: 490,
      moveStartX: 0,
      justShowHighText: false,
      articleShow: false,
      allParagraphShow: [],
      collectShow: false,
      uploadShow: false,
      collectGroup: '',
      collectGroupList: [],
      collectModal: {
        show: false,
        detail: null
      },
      currentRecommend: null,
      recommendLoading: false,
      recommendFieldPromise: {
        promise: null,
        value: null
      },
      showBatchConfirm: false,
      batchLoading: false,
      batchField: {
        field: null,
        typeVal: ''
      },
      fieldTypeVal: [],
      fieldTypeLoading: false,
      resetModal: {
        show: false,
        fieldDetail: null
      },
      unitVal: 'case',
      courseUnitGroups: [],
      notAggFieldNames: [],
      customAggEditorShow: false,
      crimeReason: '',
      crimeReasonArr: [],
      mulitDelShow: false,
      resetDelShow: false,
      mulitCheckArr: [],
      delAllLoading: false,
      delMulitLoading: false,
      resetAllLoading: false,
      resetDelLoading: false,
      fieldPaneInfo: {
        show: false,
        mode: '',
        fieldDetail: null,
        fieldDefaultInfo: null
      },
      fieldsModalShow: false,
      sortCascaderExpandArr: [],
      groupEditorShow: false,
      delUnitModal: {
        show: false,
        detail: null,
        init: function(item) {
          this.detail = item;
          this.show = true;
        }
      }
    };
  },
  provide() {
    return {
      courseUnitGroups: computed(() => this.courseUnitGroups),
      curUnitGroup: computed(() => this.curUnitGroup)
    };
  },
  filters: {
    pageFilterDisabled(type, pageInfo) {
      const { total, page, size } = pageInfo;
      if (total === 0) {
        return true;
      }
      if (type === 'prev' && page === 1) {
        return true;
      }
      if (type === 'next' && page * size >= total) {
        return true;
      }
      return false;
    },
    collectGroupFilter(id, list) {
      const item = list.find(o => o.id === id);
      return item ? item.groupName : '';
    }
  },
  watch: {
    mulitDelShow(val) {
      if (!val) {
        this.mulitCheckArr = [];
      }
    },
    resetDelShow(val) {
      if (!val) {
        this.mulitCheckArr = [];
      }
    },
    collectShow(val) {
      if (!val) {
        this.collectGroup = '';
      }
    },
    'fieldPaneInfo.show'(val) {
      if (!val && this.preOriginDataHide) {
        this.originDataHide = this.preOriginDataHide === 'hide';
      }
    }
  },
  computed: {
    isAdmin() {
      return !!this.$store.getters.isAdmin;
    },
    courseTitle() {
      if (!this.courseDetail) {
        return '';
      }
      let title = this.courseDetail._source.title || '';
      if (this.currentResearch) {
        title = this.currentResearch.title;
      }
      return `数据清洗：${title}`;
    },
    chartIndex() {
      if (!this.courseDetail || this.chartIndexId === -1) {
        return -1;
      }
      return this.courseDetail._source.chart.findIndex(chartItem => chartItem.index_id === this.chartIndexId);
    },
    currentResearch() {
      if (!this.courseDetail || this.chartIndex === -1) {
        return null;
      }
      return this.courseDetail._source.chart[this.chartIndex];
    },
    isCourseCleaner() {
      return !this.currentResearch;
    },
    mergeDataSource() {
      const query = [...this.courseFilterArr, ...this.conditionFilterArr];
      if (this.crimeReason) {
        query.push({
          byCleaner: true,
          columnInfo: fullCrimeReason,
          formData: {
            keywordArr: [this.crimeReason],
            crimeReason: 'remote',
            rule: 'term'
          }
        });
      }
      return JSON.stringify({ query });
    },
    searchOfParagraph() {
      const searchFilterArr = [...this.courseFilterArr];
      if (!this.isCourseCleaner) {
        searchFilterArr.push(...this.conditionFilterArr);
      }
      return searchFilterArr.filter(item => item.isTextFilter);
    },
    researchFields() {
      return (this.currentResearch && this.currentResearch.fields) || [];
    },
    courseFields() {
      return (this.courseDetail && this.courseDetail._source.fields) || [];
    },
    curHideAndSort() {
      if (!this.courseDetail) {
        return { sortIds: [], hideIds: [] };
      }

      const { hideAndSort = {} } = this.currentResearch || this.courseDetail._source;
      const { sortIds = [], hideIds = [] } = hideAndSort[this.unitVal] || {};

      return { sortIds, hideIds };
    },
    curFields() {
      const arr = this.isCourseCleaner ? this.courseFields : this.researchFields;

      return sortFields(arr, this.curHideAndSort.sortIds);
    },
    tableColumns() {
      return this.curFields.filter(fieldDetail => !this.curHideAndSort.hideIds.includes(fieldDetail._id));
    },
    courseConditionArr() {
      if (!this.courseDetail) {
        return [];
      }
      return (this.courseDetail._source.condition && JSON.parse(this.courseDetail._source.condition)) || [];
    },
    toolActions() {
      return {
        label: {
          actions: [
            { action: 'label', formatter: fieldTitle => `已标注 - ${fieldTitle}` },
            { action: 'noneLabel', formatter: fieldTitle => `未标注 - ${fieldTitle}` }
          ]
        },
        sort: {
          actions: [
            { action: 'asc', title: '升序' },
            { action: 'desc', title: '降序' }
          ]
        },
        customSort: {
          actions: [{ action: 'customSort', title: '自定义排序' }]
        },
        filter: { actions: [{ action: 'filter', title: '筛选器' }] },
        agg: {
          isUnitCellAction: true,
          actions: [
            { action: 'agg', title: '聚合' },
            { action: 'notAgg', title: '不聚合' }
          ]
        },
        customAgg: { isUnitCellAction: true, actions: [{ action: 'customAgg', title: '自定义数据聚合方式' }] },
        hideField: {
          actions: [
            { action: 'hideFieldOfAllGroup', title: '全部分组隐藏标签' },
            { action: 'hideFieldOfGroup', title: '仅该分组隐藏标签' }
          ]
        }
      };
    },
    caseTagArr() {
      return [
        { field_name: 'base_caseType', type: 'text', deputy_type: 'dict' },
        { field_name: 'procedureType', type: 'text', deputy_type: 'dict' },
        { field_name: 'base_nature', type: 'text', deputy_type: 'dict' }
      ];
    },
    mulitAllCheck() {
      if (this.mulitCheckArr.length === 0) {
        return false;
      }
      return this.caseList.length === this.mulitCheckArr.length;
    },
    selectParagraphArr() {
      const selectParagraphArrIds = this.selectParagraphArrIds.filter(id => {
        return id !== 'para_content';
      });
      if (!selectParagraphArrIds.length) {
        return [];
      }
      const selectParagraphArr = [];
      const arr = [...this.paragraphTree];
      let item = null;
      while ((item = arr.shift())) {
        const haveChildren = (item.children || []).length;
        if (selectParagraphArrIds.includes(item.key)) {
          selectParagraphArr.push(item);
          haveChildren && selectParagraphArr.push(...item.children);
        } else {
          haveChildren && arr.push(...item.children);
        }
      }
      return selectParagraphArr;
    },
    headerShowKeys() {
      return ['collectShow', 'showBatchConfirm', 'mulitDelShow', 'resetDelShow', 'uploadShow'];
    },
    backText() {
      if (this.chartIndex !== -1) {
        return '返回研究点';
      }
      return '返回课题';
    },
    curSortInfo: {
      get() {
        if (this.isCourseCleaner) {
          return this.courseSortInfo;
        }
        return this.researchSortInfo;
      },
      set(val) {
        if (this.isCourseCleaner) {
          this.courseSortInfo = val;
        } else {
          this.researchSortInfo = val;
        }
      }
    },
    curSortInfoCustom: {
      get() {
        if (this.isCourseCleaner) {
          return this.courseSortInfoCustom;
        }
        return this.researchSortInfoCustom;
      },
      set(val) {
        if (this.isCourseCleaner) {
          this.courseSortInfoCustom = val;
        } else {
          this.researchSortInfoCustom = val;
        }
      }
    },
    sortOptions() {
      const childArr = [
        {
          value: 'asc',
          label: '升序'
        },
        {
          value: 'desc',
          label: '降序'
        }
      ];

      let defaultSortOptions = [
        {
          value: judgementDate.columnKey,
          label: judgementDate.title,
          detail: judgementDate,
          children: childArr
        },
        {
          value: caseNumber.columnKey,
          label: caseNumber.title,
          detail: caseNumber,
          children: childArr
        }
      ];
      if (this.courseDetail && !sysCaseWays.includes(this.courseDetail._source.instrumentType)) {
        defaultSortOptions = [
          {
            value: caseBaseTitle.columnKey,
            label: caseBaseTitle.title,
            detail: caseBaseTitle,
            children: childArr
          }
        ];
      }
      return uniqBy(
        [
          {
            value: '',
            label: '默认排序'
          },
          ...defaultSortOptions,
          ...this.curFields.map(fieldItem => {
            return {
              value: fieldItem.columnKey,
              label: fieldItem.title,
              detail: fieldItem,
              children: childArr
            };
          })
        ],
        'value'
      );
    },
    sortVal() {
      if (!this.curSortInfo) {
        return [];
      }
      return [this.curSortInfo.fieldInfo.title, this.curSortInfo.action];
    },
    fieldThemeEnum() {
      const themeEnum = {};
      this.highLightFields.forEach(item => {
        themeEnum[item._id] = item.fieldThemeName;
      });
      return themeEnum;
    },
    curUnitGroup() {
      return this.courseUnitGroups.find(o => o.id === this.unitVal);
    }
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem('DATA_CLEANER_FILTER_INFO');
    next();
  },
  beforeDestroy() {
    eventBus.$off('changeCourseUnitGroups', this.changeCourseUnitGroups);
  },
  created() {
    this.fetchFieldTypeVal = debounce(this.fetchFieldTypeVal.bind(this), 300);
    this.searchHandle = debounce(this.searchHandle.bind(this), 300);
    this.fetchCrimeReasonArr = debounce(this.fetchCrimeReasonArr.bind(this), 300);
    eventBus.$on('changeCourseUnitGroups', this.changeCourseUnitGroups);
  },
  async mounted() {
    this.initHandle();
    this.initGroupHandle();
    this.fetchCrimeReasonArr();
    const paragraphArr = await services.labelRelation.getParagraph(this.$route.query.courseware_id);
    this.paragraphTree = arrayToTree(paragraphArr, { key: 'key', parentKey: 'levelId' }).filter(
      item => item.key !== 'para_content'
    );
    this.isInit = true;
  },
  methods: {
    showGroupEditor() {
      this.groupEditorShow = true;
      this.$refs.unitSelectRef.blur();
    },
    tapShowHandle(type) {
      const preCollectShow = this.collectShow;
      const preUploadShow = this.uploadShow;
      const preResetDelShow = this.resetDelShow;
      this.headerShowKeys.forEach(key => {
        if (type === key) {
          this[key] = !this[key];
        } else {
          this[key] = false;
        }
      });
      this.firstTotal = -1;
      if (
        preCollectShow !== this.collectShow ||
        preResetDelShow !== this.resetDelShow ||
        preUploadShow !== this.uploadShow
      ) {
        this.refreshPageHandle();
      }
    },
    disabledFilter() {
      if (this.currentRecommend) {
        return true;
      }
      // if (this.unitVal !== 'case' && tabKey !== 'showBatchConfirm') {
      //   return true;
      // }
      return false;
    },
    changeUnitHandler() {
      this.notAggFieldNames = [];
      this.headerShowKeys.forEach(key => (this[key] = false));
      this.changePageFilterHandle();
    },
    changeReasonHandler() {
      this.changePageFilterHandle();
    },
    refreshPageHandle() {
      this.resetCaseInfo();
      this.changePageFilterHandle();
      this.$refs.statisticsRef.refreshStatisticsHandle();
    },
    changePageFilterHandle() {
      const currentSessionInfo = JSON.parse(sessionStorage.getItem('DATA_CLEANER_FILTER_INFO') || '{}');
      sessionStorage.setItem(
        'DATA_CLEANER_FILTER_INFO',
        JSON.stringify({
          ...currentSessionInfo,
          unitVal: this.unitVal,
          notAggFieldNames: this.notAggFieldNames,
          crimeReason: this.crimeReason,
          pageNum: this.pageInfo.page,
          collectShow: this.collectShow ? 1 : 0,
          collectGroup: this.collectShow ? this.collectGroup : '',
          resetDelShow: this.resetDelShow ? 1 : 0
        })
      );
      this.getCaseList();
    },
    updMulitCaseHandle(caseId) {
      const index = this.mulitCheckArr.findIndex(id => id === caseId);
      if (index === -1) {
        this.mulitCheckArr.push(caseId);
      } else {
        this.mulitCheckArr.splice(index, 1);
      }
    },
    checkAllHandle() {
      let mulitCheckArr = [];
      if (!this.mulitAllCheck) {
        mulitCheckArr = this.caseList.map(item => item.caseId);
      }
      this.mulitCheckArr = mulitCheckArr;
    },
    changeFieldHandle() {
      this.batchField.typeVal = '';
      this.fetchFieldTypeVal();
    },
    async fetchCrimeReasonArr(word = '') {
      try {
        const result = await services.caseRule.getKeywordByField({
          courseware_id: this.$route.query.courseware_id,
          labelId: fullCrimeReason.columnKey,
          keyword: word
        });
        this.crimeReasonArr = Object.freeze(result.data.map(o => o.label));
      } catch (err) {
        this.$error(err);
      }
    },
    async fetchFieldTypeVal(word = '') {
      if (
        !this.batchField.field ||
        this.batchField.field.type !== 'text' ||
        this.batchField.field.deputy_type !== 'dict'
      ) {
        this.fieldTypeVal = [];
        return;
      }
      try {
        this.fieldTypeLoading = true;
        const { data } = await services.caseRule.getFieldDictVal({
          labelId: this.batchField.field._id,
          keyword: word,
          courseId: this.courseDetail._id
        });
        this.fieldTypeVal = data.dict_value;
      } catch (err) {
        this.$error(err);
      } finally {
        this.fieldTypeLoading = false;
      }
    },
    changeSelectParagraphHandle(val) {
      if (val.length < 1) {
        this.allParagraphShow = [];
      }
      const addNew = val.filter(id => !this.preSelectParagraphArrIds.includes(id));
      const allChildIds = [];
      this.paragraphTree.forEach(item => {
        if (addNew.includes(item.key)) {
          (item.children || []).forEach(subItem => allChildIds.push(subItem.key));
        }
      });

      this.selectParagraphArrIds = [...new Set([...this.selectParagraphArrIds, ...allChildIds])];
      this.preSelectParagraphArrIds = [...this.selectParagraphArrIds];
    },
    async batchConfirmFieldHandle(params) {
      if (this.pageInfo.total.length < 1) {
        this.$message.warning('当前筛选条件并无案件');
        return;
      }
      if (!this.batchField.field) {
        this.$message.warning('请选择标签后再批量设置');
        return;
      }
      if (this.batchField.field.deputy_type === 'dict' && !this.batchField.typeVal) {
        this.$message.warning('请选择标签分类后再批量设置');
        return;
      }
      const { isClear } = params;
      let text = '是否确认所有案件标注该标签？';
      if (isClear) {
        text = '是否确认所有案件清空该标签？';
      }
      await this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      try {
        this.batchLoading = true;

        let queryBody = this.fetchQueryBody();

        const labelInfo = { id: this.batchField.field.columnKey };
        if (this.batchField.typeVal) {
          labelInfo.value = this.batchField.typeVal;
        }

        queryBody = {
          ...queryBody,
          operateType: isClear ? 'delete' : 'add',
          labelIds: [labelInfo],
          textFilter: this.searchOfParagraph
        };
        await services.courseware.bacthSetFieldTag(queryBody);

        if (isClear) {
          services.logger.handleLog({ operateName: '搜索清除标注' });
          this.$message.success('标签已清空');
        } else {
          services.logger.handleLog({ operateName: '搜索标注' });
          this.$message.success('标签确认成功');
        }

        this.$refs.statisticsRef.refreshHandle();
        this.batchField.field = null;
        this.batchField.typeVal = '';
        this.showBatchConfirm = false;
        this.searchHandle();
      } catch (err) {
        this.$error(err);
      } finally {
        this.batchLoading = false;
      }
    },
    async confirmRecommendHandle(options) {
      let currentRecommend = this.currentRecommend;
      const { isClear = false, justClear = false, fieldDetail = null } = options;

      if (justClear) {
        if (!fieldDetail || fieldDetail !== currentRecommend) {
          return;
        }
        this.currentRecommend = null;
        this.recommendFieldPromise = {};
        currentRecommend = fieldDetail;
      } else {
        if (this.pageInfo.total.length < 1) {
          this.$message.error('当前标签没有推荐');
          return;
        }
        let text = `确认把推荐的${this.pageInfo.total.toLocaleString()}个结果全部标注为“${currentRecommend.title}”?`;
        if (isClear) {
          const h = this.$createElement;
          text = h('div', null, [
            h('div', { style: { marginBottom: '10px', fontSize: '16px' } }, '确认清除全部推荐结果？'),
            h(
              'div',
              { style: { lineHeight: '19px' } },
              '清除后，将会基于新的确认过的标签描述来推荐，再推荐与该标签相似的描述供你标注！'
            )
          ]);
        }
        await this.$msgbox({
          title: '提示',
          message: text,
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
      }

      try {
        this.recommendLoading = true;

        let queryBody = this.fetchQueryBody();

        queryBody = {
          ...queryBody,
          operateType: isClear ? 'delete' : 'add',
          type: '推荐',
          courseware_id: this.$route.query.courseware_id,
          labelIds: [{ id: currentRecommend.columnKey }]
        };
        await services.courseware.bacthSetFieldTag(queryBody);

        if (!justClear) {
          if (isClear) {
            services.logger.handleLog({ operateName: '清除智能推荐' });
            this.$message.success('推荐清除成功');
          } else {
            services.logger.handleLog({ operateName: '使用智能推荐' });
            this.$message.success('推荐标签标注成功');
          }
          this.resetCaseInfo();
          this.currentRecommend = null;
          this.recommendFieldPromise = {};
          await this.$nextTick();
          this.$refs.statisticsRef.refreshHandle();
          this.searchHandle();
        }

        this.recommendLoading = false;
      } catch (err) {
        this.recommendLoading = false;
        this.$error(err);
      }
    },
    updRecommendTotalHandle(info) {
      if (!this.currentRecommend) {
        return;
      }
      const item = info[this.currentRecommend.columnKey];
      if (!item) {
        return;
      }
      this.pageInfo.total = item.recommend;
    },
    async checkRecommendHandle(fieldDetail = null) {
      if (this.recommendLoading) {
        return;
      }
      if (this.currentRecommend) {
        this.currentRecommend = null;
        await this.$nextTick();
      }
      this.headerShowKeys.forEach(key => (this[key] = false));
      if (fieldDetail) {
        this.currentRecommend = fieldDetail;
        this.recommendFieldPromise = {
          promise: services.courseware.getField(fieldDetail._id),
          value: null
        };
      } else {
        this.recommendFieldPromise = {};
      }
      await this.$nextTick();
      this.$refs.statisticsRef.refreshStatisticsHandle();
      this.searchHandle();
    },
    resetSuccessHandle() {
      this.$refs.statisticsRef.refreshStatisticsHandle();
      this.searchHandle();
    },
    resetFieldTagHandle(fieldDetail) {
      if (this.currentRecommend) {
        return;
      }
      this.resetModal = { show: true, fieldDetail };
    },
    allParagraphShowHandle(caseId) {
      const index = this.allParagraphShow.findIndex(id => id === caseId);
      if (index === -1) {
        this.allParagraphShow.push(caseId);
      } else {
        this.allParagraphShow.splice(index, 1);
      }
    },
    async initGroupHandle() {
      try {
        this.collectGroupList = await services.courseware.getCollectGroup(this.$route.query.courseware_id);
      } catch (err) {
        this.$error(err);
      }
    },
    collectHandle(row) {
      if (row.isCollect) {
        this.delCollectHandle(row);
      } else {
        this.collectModal = {
          show: true,
          detail: row
        };
      }
    },
    collectSuccess(row) {
      if (row.isCollect === undefined) {
        this.$set(row, 'isCollect', true);
      } else {
        row.isCollect = true;
      }
      this.$message.success('收藏成功');
    },
    async delCollectHandle(row) {
      try {
        row.isCollect = false;
        await services.courseware.unCollect(this.courseDetail._id, row.caseId);
      } catch (err) {
        this.$error(err);
      }
    },
    dragstartHandle(event) {
      this.moveStartX = event.x;
    },
    dragendHandle(event) {
      const pageContentWidth = this.$refs.pageContentRef.clientWidth;
      const originDataWidth = this.$refs.originDataRef.clientWidth;

      // 与css的 [max-width] 及 [min-width] 相同
      const maxWidth = Math.ceil(pageContentWidth * 0.7);
      const minWidth = Math.ceil(pageContentWidth * 0.1);
      const moveX = event.x - this.moveStartX;

      let width = originDataWidth + moveX;
      if (width > maxWidth) {
        width = maxWidth;
      }
      if (width < minWidth) {
        width = minWidth;
      }

      this.originDataWidth = width;
    },
    async initHandle() {
      try {
        const [courseDetail] = await Promise.all([
          services.courseware.getCoursewareDetail(this.$route.query.courseware_id),
          this.refreshUniGroup()
        ]);

        this.courseDetail = courseDetail;

        if (this.$route.query.index_id) {
          this.chartIndexId = Number(this.$route.query.index_id);
        }

        if (this.currentResearch && this.currentResearch.relationFilterVal) {
          this.unitVal = this.currentResearch.relationFilterVal;
        }

        this.courseFilterArr = JSON.parse(this.courseDetail._source.conditionTemp || '[]');
        this.courseSortInfo = this.courseDetail._source.sortInfo;
        this.courseSortInfoCustom = this.courseDetail._source.sortInfoCustom || [];
        if (!this.isCourseCleaner) {
          this.conditionFilterArr = JSON.parse(this.currentResearch.conditionTemp || '[]');
          this.researchSortInfo = this.currentResearch.sortInfo;
          this.researchSortInfoCustom = this.currentResearch.sortInfoCustom || [];
        }
        let filterInfoBySession = sessionStorage.getItem('DATA_CLEANER_FILTER_INFO');
        // 页面刷新使用缓存中的替换
        if (filterInfoBySession && (filterInfoBySession = JSON.parse(filterInfoBySession))) {
          if (filterInfoBySession.unitVal) {
            this.unitVal = filterInfoBySession.unitVal;
          }
          if (filterInfoBySession.notAggFieldNames) {
            this.notAggFieldNames = filterInfoBySession.notAggFieldNames;
          }
          if (filterInfoBySession.crimeReason) {
            this.crimeReason = filterInfoBySession.crimeReason;
          }
          if (filterInfoBySession.pageNum) {
            this.pageInfo.page = filterInfoBySession.pageNum;
          }
          if (filterInfoBySession.collectShow) {
            this.collectShow = !!filterInfoBySession.collectShow;
            if (this.collectShow && filterInfoBySession.collectGroup) {
              this.collectGroup = filterInfoBySession.collectGroup;
            }
          }
          if (filterInfoBySession.resetDelShow) {
            this.resetDelShow = !!filterInfoBySession.resetDelShow;
          }
          if (this.isCourseCleaner) {
            this.courseFilterArr = filterInfoBySession.filterArr || [];
            this.courseSortInfo = filterInfoBySession.sortInfo || null;
            this.courseSortInfoCustom = filterInfoBySession.sortInfoCustom || [];
          } else {
            this.conditionFilterArr = filterInfoBySession.filterArr || [];
            this.researchSortInfo = filterInfoBySession.sortInfo || null;
            this.researchSortInfoCustom = filterInfoBySession.sortInfoCustom || [];
          }
        }

        if (!this.curUnitGroup) {
          this.unitVal = this.courseUnitGroups[0].id;
          this.notAggFieldNames = [];
        }

        this.getCaseList();
      } catch (err) {
        this.$error(err);
      } finally {
        this.pageInit = true;
      }
    },
    async refreshUniGroup() {
      const courseUnitGroups = await services.courseware.getCourseUnitGroups(this.$route.query.courseware_id);
      this.changeCourseUnitGroups({ courseId: this.$route.query.courseware_id, courseUnitGroups });
    },
    changeCourseUnitGroups({ courseId, courseUnitGroups }) {
      if (courseId !== this.$route.query.courseware_id) {
        return;
      }
      this.courseUnitGroups = courseUnitGroups;
      if (this.courseDetail && !this.curUnitGroup) {
        this.unitVal = this.courseUnitGroups[0].id;
        this.changeUnitHandler();
      }
    },
    async delGroupAfterHandle() {
      this.refreshUniGroup();
      this.courseDetail = await services.courseware.getCoursewareDetail(this.$route.query.courseware_id);
    },
    changePageHandle(type) {
      if (type === 'next') {
        this.pageInfo.page = this.pageInfo.page + 1;
      } else {
        this.pageInfo.page = this.pageInfo.page - 1;
      }
      this.changePageFilterHandle();
    },
    fetchQueryBody() {
      const { page, size } = this.pageInfo;
      const sortInfo = getSortInfo([this.curSortInfo], this.curSortInfoCustom);
      const fields = this.curFields.map(fieldItem => fetchFieldsQuery(fieldItem));
      const queryBody = {
        ...sortInfo,
        ...JSON.parse(this.mergeDataSource),
        fields,
        from: (page - 1) * size,
        size,
        track_total_hits: true,
        courseware_id: this.$route.query.courseware_id
      };
      if (this.notAggFieldNames.length > 0) {
        queryBody.groupLabels = this.curUnitGroup.fields
          .filter(fieldDetail => this.notAggFieldNames.includes(fieldDetail.field_name))
          .map(fieldDetail => fieldDetail.field_name);
      }
      if (this.collectShow) {
        queryBody.isCollect = true;
        if (this.collectGroup) {
          queryBody.groupId = this.collectGroup;
        }
      }
      if (this.uploadShow) {
        queryBody.isUpload = true;
      }
      if (this.resetDelShow) {
        queryBody.searchDelete = true;
      }
      if (this.currentRecommend) {
        queryBody.query = queryBody.query.filter(filterItem => {
          if (!filterItem.isLabelFilter) {
            return true;
          }
          return filterItem.info.fieldDetail.columnKey !== this.currentRecommend.columnKey;
        });
      }
      return queryBody;
    },
    fetchDefaultFields() {
      const newFields = [];
      let defaultFields = [{ ...caseNumber }];
      if (!sysCaseWays.includes(this.courseDetail._source.instrumentType)) {
        defaultFields = [{ ...caseBaseTitle }];
      }
      const caseUnitFieldArr = [...(this.curUnitGroup.fields || [])];
      [...defaultFields, ...this.caseTagArr, ...caseUnitFieldArr].forEach(fieldItem => {
        newFields.push(fetchFieldsQuery(fieldItem));
      });
      return newFields;
    },
    async getCaseList(options) {
      const { scrollTop = true } = options || {};
      try {
        this.tableLoading = true;

        const queryBody = this.fetchQueryBody();
        const newFields = this.fetchDefaultFields();
        queryBody.fields.push(...newFields);

        if (this.currentRecommend) {
          queryBody.query.push({
            isRecommend: true,
            info: {
              fieldDetail: this.currentRecommend
            }
          });
        }

        const isCaseUnit = this.unitVal === 'case';

        if (!isCaseUnit) {
          queryBody.parentId = this.unitVal;
        }

        const promises = [
          services.originCase.getCaseLabelList(queryBody, {
            includeCleanerFilter: true,
            recommendField: this.currentRecommend
          })
        ];

        if (this.currentRecommend && this.recommendFieldPromise.promise) {
          promises.push(this.recommendFieldPromise.promise);
        }

        const [{ hits, total, caseTotal }, recommendResult = null] = await Promise.all(promises);

        let caseList = [];

        if (isCaseUnit) {
          caseList = hits;
        } else {
          caseList = uniqBy(hits, 'caseId');
        }

        this.mulitCheckArr = [];
        this.tableList = hits;
        this.caseList = caseList;
        this.allParagraphShow = [];
        if (this.firstTotal === -1) {
          this.firstTotal = total || 0;
        }
        this.pageInfo.total = total || 0;
        this.caseTotal = caseTotal;

        if (recommendResult) {
          const recommendFieldDetail = this.curFields.find(item => {
            return item._id === this.currentRecommend._id;
          });
          this.recommendFieldPromise.value = { ...recommendResult.recommendKeyword, recommendFieldDetail };
        }

        if (scrollTop) {
          await this.$nextTick();
          this.scrollCaseId = this.caseList.length > 0 ? this.caseList[0].caseId : '';
          const tableEl = this.$refs.originDataTableRef;
          tableEl && tableEl.scrollToTopHandle();
        }
      } catch (err) {
        this.$error(err);
      } finally {
        this.tableLoading = false;
      }
    },
    searchHandle() {
      this.resetCaseInfo();
      this.getCaseList();
    },
    resetCaseInfo() {
      this.caseList = [];
      this.tableList = [];
      this.pageInfo = { ...defaultPageInfo };
      this.caseTotal = 0;
    },
    delFilterHandle(type, index) {
      const filterArr = [...(type === 'course' ? this.courseFilterArr : this.conditionFilterArr)];
      filterArr.splice(index, 1);
      this.changeTableFilter(filterArr);
    },
    confirmTextFilterHandle() {
      const labelText = this.labelText;
      if (!labelText) {
        this.$message.warning('请输入文本');
        return;
      }
      const filterArr = [...(this.isCourseCleaner ? this.courseFilterArr : this.conditionFilterArr)];
      let paragraphKeys = ['para_content'];
      if (this.selectParagraphArrIds.length > 0) {
        paragraphKeys = [...this.selectParagraphArrIds];
      }
      filterArr.unshift({
        byCleaner: true,
        isTextFilter: true,
        info: { selects: paragraphKeys, text: labelText }
      });
      this.labelText = '';
      const headerShowKey = this.headerShowKeys.find(key => this[key]);
      if (!headerShowKey) {
        this.showBatchConfirm = true;
      }
      this.batchField = { field: null, typeVal: '' };
      this.changeTableFilter(filterArr);
    },
    filterLabelHandle(type, params) {
      const { headerItem } = params;
      const filterArr = [...(this.isCourseCleaner ? this.courseFilterArr : this.conditionFilterArr)];
      const index = filterArr.findIndex(filterItem => {
        if (!filterItem.isLabelFilter) {
          return;
        }
        const { type: infoType, fieldDetail } = filterItem.info;
        return infoType === type && fieldDetail.columnKey === headerItem.columnKey;
      });
      if (index > -1) {
        this.$message.warning('已存在该筛选条件');
        return;
      }
      const reverseType = type == 'none' ? 'label' : 'none';
      const reverseIndex = filterArr.findIndex(filterItem => {
        if (!filterItem.isLabelFilter) {
          return;
        }
        const { type: infoType, fieldDetail } = filterItem.info;
        return infoType === reverseType && fieldDetail.columnKey === headerItem.columnKey;
      });
      if (reverseIndex > -1) {
        filterArr.splice(reverseIndex, 1);
      }
      filterArr.unshift({
        byCleaner: true,
        isLabelFilter: true,
        info: { type, fieldDetail: headerItem }
      });
      this.changeTableFilter(filterArr);
    },
    async changeTableFilter(filterArr) {
      this[this.isCourseCleaner ? 'courseFilterArr' : 'conditionFilterArr'] = filterArr;

      this.resetCaseInfo();

      const currentSessionInfo = JSON.parse(sessionStorage.getItem('DATA_CLEANER_FILTER_INFO') || '{}');
      sessionStorage.setItem(
        'DATA_CLEANER_FILTER_INFO',
        JSON.stringify({
          ...currentSessionInfo,
          filterArr,
          pageNum: this.pageInfo.page
        })
      );

      this.getCaseList();

      // 避免上面【 filterArr 】赋值后，props未更新就调用了刷新
      this.$nextTick(() => {
        this.$refs.statisticsRef.refreshStatisticsHandle();
      });
    },
    changeSortHandle(val) {
      if (val[0] === '') {
        if (this.curSortInfo) {
          this.sortHandle(this.curSortInfo.action, { headerItem: this.curSortInfo.fieldInfo });
          this.$refs.sortPopoverRef.doClose();
        }
        return;
      }
      const item = this.sortOptions.find(o => o.value === val[0]);
      this.sortHandle(val[1], { headerItem: item.detail });
      this.$refs.sortPopoverRef.doClose();
    },
    async sortHandle(sortAction, params) {
      const { headerItem } = params;
      const currentSortInfo = this.curSortInfo;
      let newSortInfo = { action: sortAction, fieldInfo: headerItem };
      if (
        currentSortInfo &&
        currentSortInfo.action === sortAction &&
        currentSortInfo.fieldInfo.columnKey === headerItem.columnKey
      ) {
        newSortInfo = null;
      }

      this.curSortInfo = newSortInfo;

      const currentSessionInfo = JSON.parse(sessionStorage.getItem('DATA_CLEANER_FILTER_INFO') || '{}');
      sessionStorage.setItem(
        'DATA_CLEANER_FILTER_INFO',
        JSON.stringify({
          ...currentSessionInfo,
          sortInfo: newSortInfo
        })
      );

      this.resetCaseInfo();
      this.getCaseList();
    },
    customSortModalShowHandle(fieldDetail) {
      this.customSortModal = {
        show: true,
        fieldDetail
      };
    },
    changeSortInfoCustom(sortInfoCustom = []) {
      this.curSortInfoCustom = sortInfoCustom;
      const currentSessionInfo = JSON.parse(sessionStorage.getItem('DATA_CLEANER_FILTER_INFO') || '{}');
      sessionStorage.setItem(
        'DATA_CLEANER_FILTER_INFO',
        JSON.stringify({
          ...currentSessionInfo,
          sortInfoCustom: sortInfoCustom
        })
      );
      this.resetCaseInfo();
      this.getCaseList();
    },
    delFieldHandle({ _id: fieldId }) {
      this.$confirm('删除该标签后，会同时删除该课题标签及对应标注数据，请确认是否继续删除', '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action !== 'confirm') {
            done();
            return;
          }
          try {
            instance.confirmButtonLoading = true;

            await services.courseware.delField(fieldId);

            const courseFields = this.courseDetail._source.fields.filter(item => item._id !== fieldId);
            const chart = (this.courseDetail._source.chart || []).map(chartItem => {
              const fields = (chartItem.fields || []).filter(item => item._id !== fieldId);
              return {
                ...chartItem,
                fields
              };
            });

            const newCourseSource = {
              ...this.courseDetail._source,
              fields: courseFields,
              chart
            };

            await services.courseware.saveCourseware(this.$route.query.courseware_id, newCourseSource);
            this.courseDetail._source = newCourseSource;

            this.$message.success('删除成功');
            done();
          } catch (err) {
            this.$error(err);
          } finally {
            instance.confirmButtonLoading = false;
          }
        }
      });
    },
    removeFieldHandle({ headerItem }) {
      this.$confirm(
        '移除该标签后，仅移除当前数据清洗页面右侧标签展示，仍保留该课题标签及对应标注数据，请确认是否继续移除',
        '操作提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          beforeClose: async (action, instance, done) => {
            if (action !== 'confirm') {
              done();
              return;
            }
            try {
              instance.confirmButtonLoading = true;
              const fields = this.isCourseCleaner
                ? [...this.courseDetail._source.fields]
                : [...this.currentResearch.fields];
              const index = fields.findIndex(item => item.columnKey === headerItem.columnKey);
              fields.splice(index, 1);

              let newCourseSource = { ...this.courseDetail._source };

              if (this.isCourseCleaner) {
                newCourseSource = { ...newCourseSource, fields };
              } else {
                const charts = [...newCourseSource.chart];
                charts.splice(this.chartIndex, 1, { ...this.currentResearch, fields });
                newCourseSource = { ...newCourseSource, chart: charts };
              }
              await services.courseware.saveCourseware(this.$route.query.courseware_id, newCourseSource);
              this.courseDetail._source = newCourseSource;
              done();
            } catch (err) {
              this.$error(err);
            } finally {
              instance.confirmButtonLoading = false;
            }
          }
        }
      );
    },
    hideFieldHandle(headerItem, allGroup) {
      this.$confirm(`是否隐藏标签${headerItem.title}`, '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action !== 'confirm') {
            done();
            return;
          }
          try {
            instance.confirmButtonLoading = true;

            const { hideAndSort = {} } = this.currentResearch || this.courseDetail._source;

            const newHideAndSort = {};

            const unitGroupIds = this.courseUnitGroups.map(o => o.id);

            (allGroup ? unitGroupIds : [this.unitVal]).forEach(unitGroupId => {
              const { hideIds = [], sortIds = [] } = hideAndSort[unitGroupId] || {};

              newHideAndSort[unitGroupId] = {
                hideIds: [...new Set([...hideIds, headerItem._id])],
                sortIds: sortIds.filter(fieldId => fieldId !== headerItem._id)
              };
            });

            let newCourseSource = { ...this.courseDetail._source };

            if (this.isCourseCleaner) {
              newCourseSource = { ...newCourseSource, hideAndSort: newHideAndSort };
            } else {
              const charts = [...newCourseSource.chart];
              charts.splice(this.chartIndex, 1, { ...this.currentResearch, hideAndSort: newHideAndSort });
              newCourseSource = { ...newCourseSource, chart: charts };
            }
            await services.courseware.saveCourseware(this.$route.query.courseware_id, newCourseSource);
            this.courseDetail._source = newCourseSource;
            done();
          } catch (err) {
            this.$error(err);
          } finally {
            instance.confirmButtonLoading = false;
          }
        }
      });
    },
    importSuccessHandle() {
      this.headerShowKeys.forEach(key => (this[key] = false));
      this.firstTotal = -1;
      this.refreshPageHandle();
    },
    refreshCourseDetail(detail) {
      if (this.courseDetail !== detail) {
        this.courseDetail = detail;
        this.getCaseList({ scrollTop: false });
      }
    },
    showFieldPaneHandle(mode, options = {}) {
      if (this.fieldPaneInfo.show) {
        this.$message.warning('当前正在编辑标签，请先关闭后重试');
        return;
      }
      const { fieldDetail = null, fieldDefaultInfo = null } = options;
      this.fieldPaneInfo.mode = mode;
      this.fieldPaneInfo.fieldDetail = fieldDetail;
      this.fieldPaneInfo.fieldDefaultInfo = fieldDefaultInfo;
      this.fieldPaneInfo.show = true;
      this.preOriginDataHide = this.originDataHide ? 'hide' : 'open';
      this.originDataHide = true;
    },
    async updCaseLabelRelationHandle(params) {
      const { rowIndex, rowDetail, queryBody, callback, tipMsg } = params;
      const msgEl = tipMsg ? this.$message({ message: tipMsg, duration: 0 }) : null;
      try {
        await services.caseRule.moveRelationTagOfCase(queryBody);

        await this.refreshRowSingle({ rowDetail, rowIndex });

        this.$refs.statisticsRef.refreshHandle();
        callback && callback({ pass: true });
      } catch (err) {
        callback && callback({ pass: false });
        this.$error(err);
      } finally {
        tipMsg && msgEl.close();
      }
    },
    async addCaseLabelHandle(params) {
      const { rowIndex, labelInfo, rowDetail, callback, tipMsg } = params;
      const msgEl = tipMsg ? this.$message({ message: tipMsg, duration: 0 }) : null;
      try {
        await services.caseRule.addTagOfCase(rowDetail.caseId, labelInfo);

        await this.refreshRowSingle({ rowDetail, rowIndex });

        services.logger.handleLog({ operateName: '手动标注' });

        this.$refs.statisticsRef.refreshHandle();
        callback && callback({ pass: true });
      } catch (err) {
        callback && callback({ pass: false });
        this.$error(err);
      } finally {
        tipMsg && msgEl.close();
      }
    },
    async refreshRowSingle({ rowDetail, rowIndex }) {
      try {
        const queryBody = { ...this.fetchQueryBody(), query: [] };
        const newFields = this.fetchDefaultFields();
        queryBody.fields.push(...newFields);
        queryBody.caseId = rowDetail.caseId;
        queryBody.from = 0;
        if (this.unitVal !== 'case') {
          queryBody.parentId = this.unitVal;
        }
        const { hits } = await services.originCase.getCaseLabelList(queryBody, {
          includeCleanerFilter: true,
          recommendField: this.currentRecommend
        });

        if (hits.length > 0) {
          this.caseList.splice(rowIndex, 1, hits[0]);

          const caseId = this.caseList[rowIndex].caseId;
          let tableList = [...this.tableList];
          const tableIndex = tableList.findIndex(item => item.caseId === caseId);
          if (tableIndex !== -1) {
            tableList = tableList.filter(item => item.caseId !== caseId);
            tableList.splice(tableIndex, 0, ...hits);
            this.tableList = tableList;
          }
        }
      } catch (err) {
        this.$error(err);
      }
    },
    async delCaseLabelHandle(params) {
      const { ruleKey, rowIndex, tipMsg, rowDetail, labelDetailArr, callback } = params;
      const msgEl = this.$message({ message: tipMsg, duration: 0 });
      try {
        const params = {};
        params[ruleKey] = { ids: labelDetailArr };
        await services.caseRule.delTagOfCase(this.courseDetail._id, params);

        await this.refreshRowSingle({ rowDetail, rowIndex });

        this.$refs.statisticsRef.refreshStatisticsHandle();
        callback && callback({ pass: true });
      } catch (err) {
        callback && callback({ pass: false });
        this.$error(err);
      } finally {
        msgEl.close();
      }
    },
    async updCaseLabelHandle(params) {
      const { rowIndex, tipMsg, rowDetail, labelInfo, callback } = params;
      const msgEl = this.$message({ message: tipMsg, duration: 0 });
      try {
        await services.caseRule.updTagOfCase(this.courseDetail._id, {
          id: labelInfo.id,
          ...labelInfo.valueInfo
        });

        await this.refreshRowSingle({ rowDetail, rowIndex });

        this.$refs.statisticsRef.refreshStatisticsHandle();
        callback && callback({ pass: true });
      } catch (err) {
        callback && callback({ pass: false });
        this.$error(err);
      } finally {
        msgEl.close();
      }
    },
    async resetAllCaseHandle() {
      await this.$confirm(`是否恢复该筛选条件下的${this.caseTotal}个案例？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      try {
        this.resetAllLoading = true;

        const queryBody = this.fetchQueryBody();
        const keys = ['fields', 'query'];
        const params = {
          caseIds: [],
          recoveryAll: true,
          courseware_id: this.courseDetail._id
        };
        keys.forEach(key => {
          const val = queryBody[key];
          if (val) {
            params[key] = val;
          }
        });
        await services.courseware.resetCaseByCourse(params);
        this.$message.success('批量恢复成功');
        this.firstTotal = -1;
        if (this.resetDelShow) {
          await this.getCaseList({ scrollTop: false });
          this.$refs.statisticsRef.refreshStatisticsHandle();
        }
      } catch (err) {
        this.$error(err);
      } finally {
        this.resetAllLoading = false;
      }
    },
    async resetCaseMulitHandle() {
      await this.$confirm(`是否批量恢复本页${this.mulitCheckArr.length}个案例？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      try {
        this.resetDelLoading = true;
        await services.courseware.resetCaseByCourse({
          caseIds: this.mulitCheckArr,
          recoveryAll: false,
          courseware_id: this.courseDetail._id
        });
        this.$message.success('批量恢复成功');
        this.firstTotal = -1;
        if (this.resetDelShow) {
          await this.getCaseList({ scrollTop: false });
          this.$refs.statisticsRef.refreshStatisticsHandle();
        }
      } catch (err) {
        this.$error(err);
      } finally {
        this.resetDelLoading = false;
      }
    },
    async delAllCaseHandle() {
      await this.$msgbox({
        title: '提示',
        message: `是否删除该筛选条件下的${this.caseTotal}个案例？`,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      try {
        this.delAllLoading = true;
        const queryBody = this.fetchQueryBody();
        const keys = ['fields', 'courseware_id', 'query'];
        const params = {};
        keys.forEach(key => {
          const val = queryBody[key];
          if (val) {
            params[key] = val;
          }
        });
        await services.courseware.clearCaseByCourse(params);
        this.firstTotal = -1;
        this.searchHandle();
        this.$refs.statisticsRef.refreshStatisticsHandle();
        this.$message.success('批量删除成功，若为误操作，可在“删除历史”中恢复案件');
      } catch (err) {
        this.$error(err);
      } finally {
        this.delAllLoading = false;
      }
    },
    async delCaseMulitHandle() {
      await this.$msgbox({
        title: '提示',
        message: `是否批量删除本页${this.mulitCheckArr.length}个案例？`,
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      try {
        this.delMulitLoading = true;
        await services.courseware.clearCaseByCourse({
          courseware_id: this.$route.query.courseware_id,
          caseIds: this.mulitCheckArr
        });
        this.firstTotal -= this.mulitCheckArr.length;
        this.$message.success('批量删除成功，若为误操作，可在“删除历史”中恢复案件');
        await this.getCaseList({ scrollTop: false });
        this.$refs.statisticsRef.refreshStatisticsHandle();
      } catch (err) {
        this.$error(err);
      } finally {
        this.delMulitLoading = false;
      }
    },
    async delCaseHandle(item) {
      try {
        await services.courseware.clearCaseByCourse({
          courseware_id: this.$route.query.courseware_id,
          caseIds: [item.caseId]
        });
        this.firstTotal--;
        this.$message.success('删除成功');
        await this.getCaseList({ scrollTop: false });
        this.$refs.statisticsRef.refreshStatisticsHandle();
      } catch (err) {
        this.$error(err);
      }
    },
    async updFieldsHideAndSort({ hideAndSort, callback }) {
      try {
        let newCourseSource = null;

        if (this.isCourseCleaner) {
          newCourseSource = { ...this.courseDetail._source, hideAndSort };
        } else {
          const chart = (this.courseDetail._source.chart || []).map(chartItem => {
            if (this.currentResearch !== chartItem) {
              return chartItem;
            }
            return { ...chartItem, hideAndSort };
          });
          newCourseSource = { ...this.courseDetail._source, chart };
        }

        await services.courseware.saveCourseware(this.$route.query.courseware_id, newCourseSource);
        this.courseDetail._source = newCourseSource;
        callback(true);
      } catch (err) {
        this.$error(err);
        callback(false);
      }
    },
    updAggFieldHandle(mode, fieldDetail) {
      if (mode === 'agg') {
        const idx = this.notAggFieldNames.indexOf(fieldDetail.field_name);
        if (idx === -1) {
          this.$message.warning('当前标签正【聚合】中');
          return;
        }
        this.notAggFieldNames.splice(idx, 1);
        this.changePageFilterHandle();
      }

      if (mode === 'notAgg') {
        if (this.notAggFieldNames.includes(fieldDetail.field_name)) {
          this.$message.warning('当前标签已【不聚合】');
          return;
        }
        if (this.notAggFieldNames.length === this.curUnitGroup.fields.length - 1) {
          this.$message.warning('当前不聚合标签数已上限，请至少聚合一个字段');
          return;
        }
        this.notAggFieldNames.push(fieldDetail.field_name);
        this.changePageFilterHandle();
      }

      if (mode === 'customAgg') {
        this.customAggEditorShow = true;
      }
    },
    customAggChange(notAggFieldNames = []) {
      this.notAggFieldNames = notAggFieldNames;
      this.changePageFilterHandle();
    }
  }
};
</script>
<style lang="scss">
.datacleaner-filter-input-popper {
  width: 450px !important;
}
.datacleaner-filter-input-tip {
  .datacleaner-filter-input-tip-title {
    font-size: 12px;
    color: rgba(#3d465a, 0.8);
    height: 30px;
    line-height: 30px;
  }
  .datacleaner-filter-input-tip-item {
    font-size: 12px;
    color: #3d465a;
    height: 26px;
    line-height: 26px;
  }
}
.unit-select-popover {
  .unit-select-popover-tip {
    color: #9599a5;
    font-size: 12px;
    line-height: 18px;
    padding: 10px 20px;

    .el-icon-question {
      position: relative;
      top: 1px;
      font-size: 14px;
      margin-left: 2px;
    }
  }
  .el-select-dropdown__item {
    height: fit-content;
  }
  .unit-select-item-content {
    width: 320px;

    .unit-select-item-title {
      position: relative;
      box-sizing: border-box;
      color: #3d465a;
      font-size: 14px;
      line-height: 20px;
      padding-right: 30px;

      .el-button {
        position: absolute;
        right: 0;
        top: 0;
        padding: 0;
        line-height: 20px;
      }
    }
    .unit-select-item-desc {
      color: #9599a5;
      font-size: 12px;
      line-height: 20px;
      white-space: normal;
    }
  }
}
</style>
<style lang="scss" scoped>
.data-cleaner {
  $borderColor: #e8ebef;
  $statisticsPaneWidth: 280px;
  $headerContentHeight: 50px;

  box-sizing: border-box;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #f8fafd;

  .header-content {
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    height: $headerContentHeight;
    background-color: #fff;
    padding: 0 10px;
    border-bottom: 1px solid #ebeef5;
    z-index: 10;

    .filter-total {
      position: relative;
      font-size: 14px;
      color: rgba(#2c3443, 0.8);
      .filter-img {
        position: relative;
        top: 1px;
        margin-right: 3px;
        margin-left: 10px;
      }

      .iconfont {
        margin-left: 2px;
      }

      .filter-first {
        margin-left: 10px;
      }
    }

    .filter-info {
      flex: 1;
      width: 0;
      position: relative;
      white-space: nowrap;
      overflow-x: auto;
      overflow-y: hidden;

      &::-webkit-scrollbar {
        display: none;
      }

      .collect-filter-tag-btn {
        box-sizing: border-box;
        color: #0d7de0;
        background-color: #eaf6ff;
        padding: 0px 10px;
        height: 24px;
        line-height: 22px;
        border-radius: 4px;
        border-color: transparent;

        .el-icon-close {
          padding-left: 4px;
          margin-left: 2px;
        }
      }

      .tip-title {
        position: sticky;
        left: 0;
        top: 0;
        display: inline-block;
        box-sizing: border-box;
        width: 68px;
        padding-right: 12px;
        font-size: 14px;
        color: #606266;
        height: 32px;
        line-height: 32px;
        background-color: #fff;
        z-index: 10;
      }
    }
  }

  .page-content {
    position: relative;
    flex: 1;
    width: 100%;
    height: 0;
    display: flex;
    align-items: flex-start;
    overflow: hidden;

    .origin-data-content {
      position: relative;
      box-sizing: border-box;
      width: 490px;
      // 与dragendHandle函数的计算 [最大宽度] 及 [最小宽度] 相同
      min-width: 10%;
      max-width: 70%;
      height: 100%;
      background-color: #fff;
      border-right: 1px solid $borderColor;
      margin-top: -1px;
      display: flex;
      flex-direction: column;
      z-index: 12;

      &.is-absolute {
        position: absolute;
      }

      .expand-btn {
        position: absolute;
        top: 72px;
        right: -15px;
        background-color: #fff;
        box-shadow: 0px 0px 6px 2px rgba(48, 57, 69, 0.2);
        padding: 3px 5px;
        cursor: pointer;
        z-index: 12;
        border-radius: 50%;
        opacity: 0;

        & > i {
          font-size: 12px;
        }

        &:hover {
          color: #fff;
          background-color: rgba(#1991fb, 0.8);
          border-color: #1991fb;
        }
      }

      .origin-data-content-container {
        width: 100%;
        height: 0;
        flex: 1;
      }

      .case-list-footer {
        box-sizing: border-box;
        width: 100%;
        height: 36px;
        font-size: 13px;
        color: rgba(#2c3443, 0.8);
        padding: 10px;
        background-color: #fff;
        border-top: 1px solid $borderColor;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .case-list-footer-pagination {
          color: #606266;
          font-size: 13px;
          line-height: 20px;
          display: flex;
          align-items: center;
        }
      }

      .drag-item {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background-color: #409eff;
        opacity: 0;
        z-index: 11;
        cursor: col-resize;
        transition: opacity 0.3s;
      }

      &:hover {
        .drag-item {
          opacity: 1;
        }
        .expand-btn {
          opacity: 1;
        }
      }

      &.is-hide {
        position: absolute;

        .drag-item {
          display: none;
        }

        .expand-btn {
          right: -30px;
          transform: rotate(180deg);
          opacity: 1;
        }
      }
    }

    .case-list-content {
      flex: 1;
      width: 0;
      height: 100%;

      .container {
        box-sizing: border-box;
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .case-list-header {
          box-sizing: border-box;
          width: 100%;
          padding: 7px 10px;
          background-color: #fff;
          z-index: 10;
          overflow-x: auto;

          &::-webkit-scrollbar {
            display: none;
          }

          .case-list-header-form {
            display: flex;
            align-items: center;

            .case-list-header-form-li {
              margin-left: 10px;

              ::v-deep .twin-autocomplete {
                height: 34px;
                .el-input__inner {
                  height: 34px;
                  line-height: 34px;
                }
              }
              .twin-btn {
                height: 34px;
              }

              .case-list-header-form-li-label {
                display: inline-block;
                color: #606266;
                font-size: 14px;
                line-height: 32px;
                margin-right: 12px;
              }

              &:first-child {
                margin-left: 0;
              }
            }
          }

          .switch-content {
            & > span {
              color: rgba(#2c3443, 0.8);
              font-size: 12px;
              margin-right: 5px;
            }

            .switch-item {
              transform: scale(0.8);
            }

            .text-btn {
              color: rgba(#2c3443, 0.8);
              background-color: #f1f3f6;
              border-radius: 4px;
              padding: 6px 10px;

              .iconzuozhankai-xiantiao,
              .iconshouqi-xiantiao {
                display: inline-block;
                font-size: 12px;
                margin-left: 2px;
                color: #9599a5;
                transform: scale(0.8);
              }

              &:hover {
                color: #0d7de0;

                .iconzuozhankai-xiantiao,
                .iconshouqi-xiantiao {
                  color: #0d7de0;
                }
              }

              &.is-disabled {
                color: #c0c4cc !important;

                .iconzuozhankai-xiantiao,
                .iconshouqi-xiantiao {
                  color: #9599a5;
                }
              }

              &.is-active {
                color: #0d7de0;
                background-color: #eaf6ff;

                .iconzuozhankai-xiantiao,
                .iconshouqi-xiantiao {
                  color: #0d7de0;
                }
              }

              .iconshouqi-xiantiao {
                transform: rotate(180deg) scale(0.8);
              }
            }
          }
        }

        .case-tool-header {
          box-sizing: border-box;
          position: relative;
          min-height: 49px;
          background-color: #eaf6ff;
          padding: 5px 30px;
          display: flex;
          align-items: center;

          .close-btn {
            position: absolute;
            right: 5px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 14px;
            color: rgba(#3d465a, 0.8);
            padding: 5px 5px;
            cursor: pointer;
          }
          .tip-text {
            font-size: 14px;
            color: #2c3443;
          }

          .blue-btn {
            color: #1991fb;
            border: 1px solid #1991fb;
          }

          &.recommend-content {
            justify-content: space-between;
          }
        }

        .card-content {
          flex: 1;
          height: 0;

          .card-pagition {
            text-align: center;
          }
        }
      }
    }
  }

  .field-pane-content {
    width: 720px;
    height: 100%;
    border-left: 1px solid $borderColor;
  }

  .statistics-pane-content {
    position: relative;
    width: $statisticsPaneWidth;
    height: 100%;
    border-left: 1px solid $borderColor;
    margin-right: 0;

    .expand-btn {
      position: absolute;
      top: 72px;
      left: -15px;
      background-color: #fff;
      box-shadow: 0px 0px 6px 2px rgba(48, 57, 69, 0.2);
      padding: 3px 5px;
      cursor: pointer;
      z-index: 12;
      border-radius: 50%;
      opacity: 0;

      & > i {
        font-size: 12px;
      }

      &:hover {
        color: #fff;
        background-color: rgba(#1991fb, 0.8);
        border-color: #1991fb;
      }
    }

    .add-column-btn-content {
      box-sizing: border-box;
      padding: 15px 10px 0;
      width: 100%;
      background-color: #f9fbff;

      .add-btn {
        font-size: 14px;
        width: 100%;

        .add-icon {
          font-size: 14px;
          font-weight: bold;
        }
      }
    }

    &:hover {
      .expand-btn {
        opacity: 1;
      }
    }

    &.is-hide {
      margin-right: -$statisticsPaneWidth;

      .expand-btn {
        left: -30px;
        transform: rotate(180deg);
        opacity: 1;
      }
    }
  }
}
.course-title-content {
  display: flex;
  align-items: center;

  .course-edit-icon {
    margin-left: 2px;
    padding: 2px 3px;
    cursor: pointer;
    opacity: 0;
  }

  .title-text {
    display: inline-block;
    max-width: calc(100% - 30px);
  }

  &:hover {
    .course-edit-icon {
      opacity: 1;
    }
  }
}
</style>
